// AUTH

// GUEST
import Home from '@pages/Home';
// import TermOfUse from '../pages/Policies/TermsOfUse';
// import ExchangePolicy from '../pages/Policies/ExchangePolicy';
// import ShippingAndFulfillment from '../pages/Policies/ShippingAndFulfillment';
// import PrivacyPolicy from '../pages/Policies/PrivacyPolicy';
// import PoProgrameRnR from '../pages/Policies/PoProgrameRnR';

// USER

// ONLY CAN ACCESS AFTER LOGIN - USER
export const private_routes = [
    // SETTING  
    /* {
        path: "/setting/profile",
        component: <Profile />,
        title: 'title.profile',
        showLogo: true,
        showBackBtn : true,
        backTitle: 'title.profile',
    }, */
];

// CAN ACCESS BEFORE OR AFTER LOGIN - GUEST
export const public_routes = [
    {
        path: "/",
        component: <Home/>,
        showTutorBtn: false,
        showBackBtn : false,
        showLogo: true,
        // backTitle: 'title.home'
    },
    // {
    //     path: "/term-of-use",
    //     component: <TermOfUse/>,
    //     showTutorBtn: false,
    //     showBackBtn : false,
    //     showLogo: true,
    //     noHeader: false,
    //     // backTitle: 'title.business'
    // },
    // {
    //     path: "/exchange-policy",
    //     component: <ExchangePolicy/>,
    //     showTutorBtn: false,
    //     showBackBtn : false,
    //     showLogo: true,
    //     noHeader: false,
    //     // backTitle: 'title.business'
    // },
    // {
    //     path: "/shipping-and-fulfillment",
    //     component: <ShippingAndFulfillment/>,
    //     showTutorBtn: false,
    //     showBackBtn : false,
    //     showLogo: true,
    //     noHeader: false,
    //     // backTitle: 'title.business'
    // },
    // {
    //     path: "/privacy-policy",
    //     component: <PrivacyPolicy/>,
    //     showTutorBtn: false,
    //     showBackBtn : false,
    //     showLogo: true,
    //     noHeader: false,
    //     // backTitle: 'title.business'
    // },
    // {
    //     path: "/po-programe-rnr",
    //     component: <PoProgrameRnR/>,
    //     showTutorBtn: false,
    //     showBackBtn : false,
    //     showLogo: true,
    //     noHeader: false,
    // }
];

// ONLY CAN ACCESS BEFORE LOGIN - AUTH
export const public_restricted_routes = [
    /* {
        path: "/register",
        component: <Register />,
        title: 'title.register',
        showBackBtn: true,
        noHeader: true,
    }, */
];

// FOR IMPORTED MEMBERS, FORCE CHANGE EMAIL
export const imported_user_restricted_routes = [
    /* {
        path: "/setting/profile",
        component: <Profile />,
        title: 'title.profile',
        
    }, */
];